<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Identifikacija kupca"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
></kodit-dropdown>
